// Global store for Employee Data
let globalEmployeeData = null;
let globalDivisionList = [];

export const setEmployeeData = (data) => {
  globalEmployeeData = data;
};

export const getEmployeeData = () => {
  return globalEmployeeData;
};

export const setDivisionList = (list) => {
  globalDivisionList = list;
};

export const getDivisionList = () => {
  return globalDivisionList;
};
